import { useOpenActiveGame } from '@ps/web-poker-active-games';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';

import type { Tournament } from '../../types/MTT';
import { ModalPath } from '../../types/common';

import useMTTGameUrl from './useMTTGameUrl';

const useMTTHandleRegister = (id?: Tournament['id'], isEnabled: Tournament['isEnabled'] = true) => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const tableUrl = useMTTGameUrl(id);
  const { openActiveGame } = useOpenActiveGame({ tableUrl });
  const isEmbedded = useSelector(select.device.isEmbedded);
  const { modal } = useDispatch<Dispatch>();

  const handleRegisterClick = useCallback(() => {
    if (!id) return;

    if (isEmbedded) {
      return window.starsweb?.app?.execute(`tourn-reg/${id}`);
    }

    if (isAuthenticated) {
      if (isEnabled) {
        openActiveGame();
      } else {
        modal.enqueue({ path: ModalPath.VerifyAccount });
      }
    } else {
      modal.unshift({ path: '/auth/login' });
    }
  }, [id, isEmbedded, isAuthenticated, modal, openActiveGame, isEnabled]);

  return handleRegisterClick;
};

export default useMTTHandleRegister;
